import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';

import { ICommonState } from './commonRedux/types';
import { IModalState } from './modal/types';

import commonReducer from './commonRedux/reducer';
import modalReducer from './modal/reducer';
import authReducer, { IAuthState } from './auth/reducer';
import timesheetReducer, { ITimesheetState } from './timesheet/reducer';
import employeesReducer, { IEmployeesState } from './employees/reducer';
import jobsReducer, { IJobsState } from './jobcodes/reducer';
import taskReducer, { ITasksState } from './task/reducer';
import phasesReducer, { IPhasesState } from './phasecodes/reducer';
import usersReducer, { IUsersState } from './users/reducer';

import contentReducer, { IContentState } from './contentRedux/reducer';

export interface IRootState {
  router: RouterState;
  common: ICommonState;
  auth: IAuthState;
  modal: IModalState;
  timesheet: ITimesheetState;
  employees: IEmployeesState;
  jobCodes: IJobsState;
  task: ITasksState;
  phaseCodes: IPhasesState;
  users: IUsersState;
  content: IContentState;
}

/* ------------- Assemble The Reducers ------------- */
const createRootReducer = (history: History) =>
  combineReducers<IRootState>({
    router: connectRouter(history),
    common: commonReducer,
    auth: authReducer,
    modal: modalReducer,
    timesheet: timesheetReducer,
    employees: employeesReducer,
    jobCodes: jobsReducer,
    task: taskReducer,
    phaseCodes: phasesReducer,
    users: usersReducer,
    content: contentReducer,
  });

export default createRootReducer;
